import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Paper, useMediaQuery, useTheme, } from '@mui/material';
import { useCallback } from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import clsx from 'clsx';
import modalPaperStyles from './modalPaper.styles';
const ModalPaper = ({ className, children, hideCloseIcon, onClose, toggleModal, ...rest }) => {
    const styles = modalPaperStyles();
    const isBelowTablet = useMediaQuery(useTheme().breakpoints.down('md'));
    const handleClose = useCallback(() => {
        if (toggleModal) {
            toggleModal(false);
        }
    }, [toggleModal]);
    return (_jsxs(Paper, { ...rest, className: className, classes: { root: styles.overlayPaper }, children: [!hideCloseIcon && (_jsx(IconButton, { onClick: onClose ? onClose : handleClose, "data-test": "button:close", className: styles.closeButton, children: isBelowTablet ? (_jsx(CancelIcon, { className: styles.closeIcon }, void 0)) : (_jsx(HighlightOffOutlinedIcon, {}, void 0)) }, void 0)), _jsx(Box, { className: clsx(className, styles.insetPaper), "data-test": "modal:section", children: children }, void 0)] }, void 0));
};
export default ModalPaper;
//# sourceMappingURL=ModalPaper.js.map